import { useCallback, useState } from "react";

/**
 * Structured notify for Bond Dice / Coin Flip.
 * Strings → lightweight toast (errors). Objects → celebration modal.
 */
export function useBondGameNotify() {
  const [toast, setToast] = useState(null);
  const [celebration, setCelebration] = useState(null);

  const notify = useCallback((payload) => {
    if (!payload) return;
    if (typeof payload === "string") {
      setToast(payload);
      setCelebration(null);
      return;
    }
    setCelebration(payload);
    setToast(null);
  }, []);

  const clearToast = useCallback(() => setToast(null), []);
  const clearCelebration = useCallback(() => setCelebration(null), []);

  return { toast, celebration, notify, clearToast, clearCelebration };
}

export default useBondGameNotify;
